export default "__VITE_ASSET__DxzOHSM___"